import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  groupPrivacyStatusDesc,
  groupRoles,
} from "../../../utils/constants";
import { CSVLink } from "react-csv";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
  ModalHeader,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import MemberItem from "../Components/MemberItem";
import noEventUsers from "../../../assets/onboarding/wStory.svg";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import OfficeMateProfile from "../../office/OfficeMateProfile/OfficeMateProfile";
import { isMobile } from "../../../utils/deviceInfo";
import OfficeMateProfileMobilePopup from "../../office/OfficeMateProfile/OfficeMateProfileMobilePopup";

class MetricsMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      members: [...this.props.members],
      membersCopy: [...this.props.members],
      dropdownOpen: false,
      isSuccess: false,
      removedItem: null,
      isAPI: false,
      profilePopupOpen: false,
      profilePopupData: {
        userId: null,
        orgId: null,
      },
    };
  }

  componentDidMount() {
    this.props.highlightMenu("M");
  }

  componentDidUpdate(prevProps, prevState) {
    let { members } = this.props;
    console.log(prevProps);
    console.log(prevState);
    if (prevProps.members.length != members.length) {
      this.setState({ members });
    }
  }

  removeMember = userId => {
    this.props.removeMember(userId);
  };

  viewMember = user => {
    let link = `/home/${this.props.user.profile.organizationId._id}/profile/${user.o_id}`;
    this.props.history.push(link);
  };

  onDismiss = () => {
    this.setState({ isSuccess: false, removedItem: null });
  };

  handleProfilePopup = user => {
    this.setState({
      profilePopupOpen: true,
      profilePopupData: {
        userId: user.o_id,
        orgId: this.props.user.profile.organizationId._id,
      },
    });
  };

  toggleProfilePopup = () => {
    if (this.state.profilePopupOpen) {
      this.setState({
        profilePopupData: {
          userId: null,
          orgId: null,
        },
      });
    }

    this.setState({ profilePopupOpen: !this.state.profilePopupOpen });
  };

  handleSearchQueryChanged = e => {
    const val = e.target.value;
    const { membersCopy } = this.state;
    if (val) {
      const newMembers = membersCopy.filter(x => {
        const firstName = x.firstName || "";
        const lastName = x.lastName || "";
        if (
          firstName.toLowerCase().includes(val.toLowerCase()) ||
          lastName.toLowerCase().includes(val.toLowerCase())
        ) {
          return x;
        }
      });
      this.setState({ members: [...newMembers] });
    } else {
      this.setState({ members: [...membersCopy] });
    }
  };
  renderMembers = tasks => {
    const { orgAdmin } = this.props.user.profile;
    let { members, isSuccess, removedItem, currentUserRole } = this.state;
    let {
      group,
      renderIntoMetricsPopup,
      membersPopupOpen,
      toggle,
    } = this.props;

    const memberStaticHeaders = [
      { label: "Member Name", key: "name" },
      { label: "Joined At", key: "joined" },
      { label: "Member Role", key: "memberRole" },
    ];

    return (
      <Modal isOpen={membersPopupOpen}>
        <ModalHeader toggle={toggle} className="metrics-mobile-header">
          Group Members
          {members.length ? (
            <div
              className={`single_group_menu_events_export_btn ${
                isMobile ? "" : "ml-5"
              }`}
            >
              <CSVLink
                data={this.getData([...members])}
                headers={memberStaticHeaders}
                filename={`Group Members - ${moment().format(
                  "MM/DD/YYYY"
                )}.csv`}
                target="_blank"
              >
                {members && members.length > 0
                  ? "Export Group Members to CSV"
                  : "No members"}
              </CSVLink>
            </div>
          ) : (
            ""
          )}
        </ModalHeader>
        <ModalBody>
          <span>
            {isSuccess ? (
              <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
                <strong>{removedItem.name}</strong> was removed.
              </Alert>
            ) : null}

            <div className="search-export-button-div">
              <InputGroup style={{ height: "40px" }}>
                <Input
                  className="toolkit-field tool-search-box"
                  placeholder="Search ..."
                  onChange={this.handleSearchQueryChanged}
                />
                <InputGroupAddon addonType="append">
                  <i
                    style={{ color: "#818389", padding: "7px" }}
                    className="flaticon-search"
                  ></i>
                </InputGroupAddon>
              </InputGroup>
            </div>

            <ul
              className={`${
                renderIntoMetricsPopup ? "member-metrics-height-scroll" : ""
              } mobile-group-members responsive-table`}
            >
              {!isMobile && (
                <li
                  className="font-weight-bold"
                  // style={whiteLabelStyling(['backgroundColor'], this.props.user.profile.organizationId)}
                >
                  <div className="col col-6">Profile</div>
                  <div className="col col-5">Role</div>

                  <div className="col col-1"></div>
                </li>
              )}

              {members.map((item, idx) => {
                return (
                  <MemberItem
                    removeMember={this.removeMember}
                    currentUserRole={currentUserRole}
                    group={group}
                    single_member={item}
                    key={item.o_id + idx}
                    handleProfilePopup={this.handleProfilePopup}
                    hideRoleSelector={renderIntoMetricsPopup}
                  />
                );
              })}
            </ul>
          </span>
        </ModalBody>
      </Modal>
    );
  };

  getData(members) {
    const membersToExport = members.map(item => ({
      name: `${item.firstName}  ${item.lastName || ""}`,
      joined: moment(item.dateJoined).format("MMM Do, YYYY"),
      memberRole: groupRoles.filter(e => e.value == item.role)[0].label,
    }));

    return membersToExport;
  }

  render() {
    let {
      members,
      isAPI,
      isLoaded,
      profilePopupData,
      profilePopupOpen,
    } = this.state;

    let { renderIntoMetricsPopup } = this.props;

    return (
      <span
        className={
          renderIntoMetricsPopup
            ? ""
            : `grp_single_page_stories_container member_component_container`
        }
      >
        <Modal isOpen={profilePopupOpen} toggle={this.toggleProfilePopup}>
          <ModalHeader toggle={this.toggleProfilePopup}>
            View member
          </ModalHeader>
          <ModalBody>
            <OfficeMateProfileMobilePopup
              officematePopupId={profilePopupData.userId}
              officematePopupOrgId={profilePopupData.orgId}
            />
          </ModalBody>
        </Modal>
        <div
          className={
            renderIntoMetricsPopup
              ? ""
              : `grp_single_page_resources_component_container`
          }
        >
          {members && members.length > 0 ? (
            this.renderMembers()
          ) : (
            <span className="group_members_page_no_users">
              <div className="event_guest_modal_no_data bgWhite boxShadow1">
                <img
                  src={noEventUsers}
                  className="event_guest_modal_no_data_img"
                />
                <span className="event_guest_modal_no_data_txt">
                  This group currently has no members
                </span>
              </div>
            </span>
          )}
        </div>
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(MetricsMembers, axios)));
